export type ConditionType =
  | 'Missing Documentation'
  | 'Price Discrepancy'
  | 'Address Mismatch'
  | 'Incomplete Data'
  | 'Verification Required'
  | 'Title Issue'
  | 'Ownership Concern'
  | 'Timeline Discrepancy'
  | 'Other'

export const CONDITION_TYPES: ConditionType[] = [
  'Missing Documentation',
  'Price Discrepancy',
  'Address Mismatch',
  'Incomplete Data',
  'Verification Required',
  'Title Issue',
  'Ownership Concern',
  'Timeline Discrepancy',
  'Other',
]

export interface Condition {
  id: string
  type: ConditionType
  notes: string
  experienceIds: string[]
  createdAt: string // ISO string
}
